<template>
  <i
    aria-hidden="true"
    :class="[type, `fa-${icon}`, sizeClass]"
    v-bind="$attrs"
  ></i>
</template>

<script>

const iconSizes = {
  small: 'fa-sm',
  medium: 'fa-lg',
  large: 'fa-2x',
};

export default {
  name: 'i-icon',
  props: {
    /**
     * The name of the icon as defined by the icon pack.
     * For example: `users`, `plus`, etc.
     */
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      validator: (value) => ['small', 'medium', 'large'].includes(value),
    },
    // TODO: simplify API: merge `type` and `icon` re: compose classes natively
    type: {
      type: String,
      default: 'fas',
      validator: (value) => ['fas', 'far', 'fal', 'fad', 'fab'].includes(value),
    },
  },
  computed: {
    sizeClass() {
      return iconSizes[this.size] || '';
    },
  },
};
</script>
